export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";

export const REGISTER_USER_REQUEST = "REGISTER_USER_REQUEST";
export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
export const REGISTER_USER_FAIL = "REGISTER_USER_FAIL";

export const LOAD_USER_REQUEST = "LOAD_USER_REQUEST";
export const LOAD_USER_SUCCESS = "LOAD_USER_SUCCESS";
export const LOAD_USER_FAIL = "LOAD_USER_FAIL";

export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";

export const USER_LOGIN_STATUS_REQUEST = "USER_LOGIN_STATUS_REQUEST";
export const USER_IS_LOGGEDIN = "USER_IS_LOGGEDIN";
export const USER_IS_LOGGEDOUT = "USER_IS_LOGGEDOUT";
export const USER_LOGIN_STATUS_FAIL = "USER_LOGIN_STATUS_FAIL";

export const UPDATE_PROFILE_REQUEST = "UPDATE_PROFILE_REQUEST";
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";
export const UPDATE_PROFILE_RESET = "UPDATE_PROFILE_RESET";
export const UPDATE_PROFILE_FAIL = "UPDATE_PROFILE_FAIL";

export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_RESET = "CHANGE_PASSWORD_RESET";
export const CHANGE_PASSWORD_FAIL = "CHANGE_PASSWORD_FAIL";

export const FORGOT_PASSWORD_REQUEST = "FORGOT_PASSWORD_REQUEST";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_RESET = "FORGOT_PASSWORD_RESET";
export const FORGOT_PASSWORD_FAIL = "FORGOT_PASSWORD_FAIL";

export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAIL = "RESET_PASSWORD_FAIL";

export const ALL_USERS_REQUEST = "ALL_USERS_REQUEST";
export const ALL_USERS_SUCCESS = "ALL_USERS_SUCCESS";
export const ALL_USERS_FAIL = "ALL_USERS_FAIL";

export const USER_DETAILS_REQUEST = "USER_DETAILS_REQUEST";
export const USER_DETAILS_SUCCESS = "USER_DETAILS_SUCCESS";
export const USER_DETAILS_FAIL = "USER_DETAILS_FAIL";

export const UPDATE_USER_REQUEST = "UPDATE_USER_REQUEST";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_RESET = "UPDATE_USER_RESET";
export const UPDATE_USER_FAIL = "UPDATE_USER_FAIL";

export const DELETE_USER_REQUEST = "DELETE_USER_REQUEST";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAIL = "DELETE_USER_FAIL";
export const DELETE_USER_RESET = "DELETE_USER_RESET";

export const ADD_SHIPPING_INFO_REQUEST = "ADD_SHIPPING_INFO_REQUEST";
export const ADD_SHIPPING_INFO_SUCCESS = "ADD_SHIPPING_INFO_SUCCESS";
export const ADD_SHIPPING_INFO_FAIL = "ADD_SHIPPING_INFO_FAIL";

export const ADD_SHIPPING_INFO_RESET = "ADD_SHIPPING_INFO_RESET";

export const GET_SHIPPING_INFO_REQUEST = "GET_SHIPPING_INFO_REQUEST";
export const GET_SHIPPING_INFO_SUCCESS = "GET_SHIPPING_INFO_SUCCESS";
export const GET_SHIPPING_INFO_FAIL = "GET_SHIPPING_INFO_FAIL";

export const GET_SINGLE_SHIPPING_INFO_REQUEST = "GET_SINGLE_SHIPPING_INFO_REQUEST";
export const GET_SINGLE_SHIPPING_INFO_SUCCESS = "GET_SINGLE_SHIPPING_INFO_SUCCESS";
export const GET_SINGLE_SHIPPING_INFO_FAIL = "GET_SINGLE_SHIPPING_INFO_FAIL";

export const DELETE_SHIPPING_INFO_REQUEST = "DELETE_SHIPPING_INFO_REQUEST";
export const DELETE_SHIPPING_INFO_SUCCESS = "DELETE_SHIPPING_INFO_SUCCESS";
export const DELETE_SHIPPING_INFO_FAIL = "DELETE_SHIPPING_INFO_FAIL";

export const DELETE_SHIPPING_INFO_RESET = "DELETE_SHIPPING_INFO_RESET";

export const CLEAR_ERRORS="CLEAR_ERRORS";